import React from 'react';

import { fg } from '@atlaskit/platform-feature-flags';
import UFOSegment from '@atlaskit/react-ufo/segment';
import { AtlassianRelayEnvironmentProvider } from '@atlassian/relay-environment-provider';

import { ConversationAssistantConfigurer } from './ConversationAssistantConfigurer';

export const ConversationAssistant = ({
	skipRelayProvider,
	...props
}: Parameters<typeof ConversationAssistantConfigurer>[0] & {
	skipRelayProvider?: boolean;
}): React.JSX.Element => {
	const rootSegmentName = props.overridingChildren
		? 'rovo-conversation-assistant-wOverriddenChildren'
		: 'rovo-conversation-assistant';

	const content = <ConversationAssistantConfigurer {...props} />;

	return (
		// The UFOSegment has to be absolute top, please do not introduce any side effects in this parent level component,
		// otherwise it may not get captured with performance metrics
		<UFOSegment name={rootSegmentName}>
			{skipRelayProvider && fg('ai_agent_sessions_warming_cache') ? (
				content
			) : (
				<AtlassianRelayEnvironmentProvider>{content}</AtlassianRelayEnvironmentProvider>
			)}
		</UFOSegment>
	);
};
